import React from 'react';
import Checkbox, { CheckboxProps } from '@westwing/ui-kit/Checkbox';

const CheckBox = (props: CheckboxProps) => {
    return <Checkbox {...props} />;
};

export default CheckBox;
